import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformancePIPListPage from "@/pages/admin/PerformancePIPListPage";

export const Route = createFileRoute("/_admin/admin/performance/pip/")({
  head: () => pageHead("Admin · Performance · Pip", "AKIVA admin · performance · pip portal.", "/admin/performance/pip", true),
  component: PerformancePIPListPage,
});
